import React from 'react';

export function EventCardWidget({ event, configuration }) {
  let eventClass = "event-card";
  let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
  let timeOptions = { hour: '2-digit', minute: '2-digit' };

  return (
    <div className={eventClass}>
      <div className="event-date-time">
        <div className="event-date">
          <i className="icon-calendar"></i>
          {new Date(event.start_date).toLocaleDateString(undefined, dateOptions)}
        </div>
        <div className="event-time">
          <i className="icon-clock"></i>
          {new Date(event.start_date).toLocaleTimeString(undefined, timeOptions)} - 
          {new Date(event.end_date).toLocaleTimeString(undefined, timeOptions)}
        </div>
      </div>
      <div className="event-title">
        <h6 className="event-title">{event.title}</h6>
      </div>
      <div className="event-more-info">
        <a href={event.url} className="button button-secondary">
          {configuration.translations.moreInfo}
        </a>
      </div>
    </div>
  );
}
